import { RequirementDefinitionTemplateForm } from "../../types";
import {
  CreateRequirementDefinitionSharedFileMimeType,
  CreateRequirementDefinitionSharedFilePartialForm
} from "../../../../../Requirements/modules/SharedFile/types";
import { BaseCreateRequirementDefinitionFormValues } from "../../../../../Requirements/types";
import { STANDARD_SHARED_FILE_FORM } from "./StandardSharedFile";
import * as Yup from "yup";

type SmartSharedFileValues = {};

export const getSmartSharedFileForm = (
  mimeTypes: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >
): RequirementDefinitionTemplateForm<
  SmartSharedFileValues,
  CreateRequirementDefinitionSharedFilePartialForm &
    Partial<BaseCreateRequirementDefinitionFormValues>
> => {
  return {
    ...STANDARD_SHARED_FILE_FORM,
    mapFormData(values, template) {
      return {
        ...values,
        name: template.name,
        mimeTypes,
        contextType: Array.isArray(template.contextType)
          ? template.contextType[0]
          : template.contextType,
        instructions: template.instructions!
      };
    },
    validationSchema: Yup.object().shape({
      instructions: Yup.string()
    }),
    getDefaultValues: template => ({}),
    partialForm: null
  };
};
